import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CheckUpdatesQueryVariables = Types.Exact<{
  androidVersionCode?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  iOSBuildNumber?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  app: Types.ClientApp;
}>;


export type CheckUpdatesQuery = { __typename?: 'Query', checkUpdates: { __typename?: 'CheckUpdatesResponse', isUpdateRequired: boolean, availableUpdate?: { __typename?: 'AppVersion', version: string, releaseNotes?: string | null } | null } };


export const CheckUpdatesDocument = gql`
    query CheckUpdates($androidVersionCode: Int, $iOSBuildNumber: Int, $app: ClientApp!) {
  checkUpdates(
    androidVersionCode: $androidVersionCode
    iOSBuildNumber: $iOSBuildNumber
    app: $app
  ) {
    isUpdateRequired
    availableUpdate {
      version
      releaseNotes
    }
  }
}
    `;

/**
 * __useCheckUpdatesQuery__
 *
 * To run a query within a React component, call `useCheckUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUpdatesQuery({
 *   variables: {
 *      androidVersionCode: // value for 'androidVersionCode'
 *      iOSBuildNumber: // value for 'iOSBuildNumber'
 *      app: // value for 'app'
 *   },
 * });
 */
export function useCheckUpdatesQuery(baseOptions: Apollo.QueryHookOptions<CheckUpdatesQuery, CheckUpdatesQueryVariables> & ({ variables: CheckUpdatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUpdatesQuery, CheckUpdatesQueryVariables>(CheckUpdatesDocument, options);
      }
export function useCheckUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUpdatesQuery, CheckUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUpdatesQuery, CheckUpdatesQueryVariables>(CheckUpdatesDocument, options);
        }
// @ts-ignore
export function useCheckUpdatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckUpdatesQuery, CheckUpdatesQueryVariables>): Apollo.UseSuspenseQueryResult<CheckUpdatesQuery, CheckUpdatesQueryVariables>;
export function useCheckUpdatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckUpdatesQuery, CheckUpdatesQueryVariables>): Apollo.UseSuspenseQueryResult<CheckUpdatesQuery | undefined, CheckUpdatesQueryVariables>;
export function useCheckUpdatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckUpdatesQuery, CheckUpdatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckUpdatesQuery, CheckUpdatesQueryVariables>(CheckUpdatesDocument, options);
        }
export type CheckUpdatesQueryHookResult = ReturnType<typeof useCheckUpdatesQuery>;
export type CheckUpdatesLazyQueryHookResult = ReturnType<typeof useCheckUpdatesLazyQuery>;
export type CheckUpdatesSuspenseQueryHookResult = ReturnType<typeof useCheckUpdatesSuspenseQuery>;
export type CheckUpdatesQueryResult = Apollo.QueryResult<CheckUpdatesQuery, CheckUpdatesQueryVariables>;